// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,400;0,500;0,700;1,400;1,500;1,700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body{
  margin: 0%;
  
}

body::-webkit-scrollbar {
  width: 0; /* Set the width of the scrollbar to a minimal value */
}

body:-webkit-scrollbar-thumb {
  background: none; /* Set the scrollbar thumb to be transparent */
}

.app {
  display: grid;
  grid-template-columns: auto 1fr; /* Sidebar takes auto width, Main content takes the remaining space */
  min-height: 100vh;
}
  
  /* Add styling for the sidebar */
  .sidebar {
      width: 100px;
      flex: 0 0 auto;
      flex-shrink: 0;
      background-color: #1F2B8F;
       transition: width 0.3s ease; 
       overflow:auto; 
      display: flex;
      flex-direction: column;
      /* align-items: center; */
      margin-right: 10px;
      /* max-height: 100vh; */
      transition: all 0.3s ease; 
      height: 100vh;
     z-index: 1; 
        position: fixed; 
  }
  .open {
      width: 200px;
  }
  
  .closed {
      width: 100px;
  }
  
  /* Add styling for the logo */
  .logo {
      padding: 0px;
      margin: 10px;
      border-radius: 10px;
      height: 60px;
      align-items: center;
      text-align: center;
      /* color: aliceblue; */
      /* background-color: #fff; */
      display: flex;
      justify-content: center;
  }
  
  .main-logo {
      /* max-width: 100%; */
      width: 130px;
      color: #fff;
  }


  .min-logo{
    width:80px;
  }
  
  /* Add styling for the sidebar tabs */
  ul {
      list-style-type: none;
      padding: 10px;
      margin: 0;

  }
  ul li{
      /* width: fit-content; */
      text-align: center !important 
    
  }
  li.tab {
      cursor: pointer;
      transition: background-color 0.3s ease, color 0.3s ease;
      align-items: center;
      display: block;
      font-size: 16px;
      font-weight: bold;
      color: #fff;
      margin-left: 5px;
      padding: 5px;
      text-align: center;
      margin-top: 5px;
      /* width: fit-content; */
      width: 140px;
      border-radius: 10px;
  }

  li.tab-min {
    cursor: pointer;
    transition: background-color 0.3s ease, color 0.3s ease;
    align-items: center;
    display: block;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    margin-left: 5px;
    padding: 5px;
    text-align: center;
    margin-top: 5px;
    /* width: fit-content; */
    width: 50px;
    border-radius: 10px;
    
}
  


  li.tab a {
      display: block;
      padding: 10px;
      width: -moz-fit-content;
      width: fit-content;
      text-align: center !important
      
/* Adjust the padding as needed for the clickable area */
    }

    li.tab-min a {
      display: block;
      padding: 10px;
      width: 50% !important;
      
    
      
/* Adjust the padding as needed for the clickable area */
    }
  
  li.tab.active {
      background-color: #50C878;
      color:white;
      border-radius: 10px;
  }

  li.tab-min.active {
    background-color: #50C878;
    color:white;
    width: 50px;
    border-radius: 10px;
}
  
  li.tab:hover  {
      background-color: #50C878;
      border-radius: 10px;
      cursor: pointer;
      padding: 5px;
  }
  li.tab-min:hover  {
    background-color: #50C878;
    border-radius: 10px;
    cursor: pointer;
    padding: 5px;
}
  .collapse-icon {
      padding: 10px;
      cursor: pointer;
      margin-top: auto;
      text-align: center;
      color: brown;
      /* background-color: black; */
      
  }
  
  /* Add styling for the chevron icons */
  .fa-chevron-left,
  .fa-chevron-right {
      transition: transform 0.3s ease;
      color: red;
  }
  
  .fa-chevron-left {
      transform: rotate(-180deg);
  }
  
  .fa-chevron-right {
      transform: rotate(0deg);
  }

  .main-div{
      /* z-index: 0;  */
      /* position: sticky; */
      /* padding-left: 500px; */
      width: -moz-fit-content;
      width: fit-content;
      margin-left: 200px;
  }


  .main-content {
      /* max-height: calc(100vh - 120px); Adjust the 120px value as needed */
      height: calc(100vh-10px); 
      margin-left: 200px; 
       /* margin-top: 50px;  
      /* Add any additional styles you want for the main content area */
       /* This allows the main content area to grow and fill the remaining space */
       overflow: auto;
      flex:1 1;
      flex-shrink: 0;
      margin-top: 38px;
      /* width: 1150px; */
      width: calc(100vw - 200px);
      /* display: flex; */
      /* justify-content: center; */
      transition: all 0.3s ease; 
      z-index: 0;
    
      /* transition: all 0.3s ease; 
     
      /* border-radius: 50px; */
      /* padding-left: 30px; */
  }

  .min-content{
      /* min-height: 100vh;  */
      margin-top: 38px;
      flex:1 1;
      /* width: 100vw; */
      width: calc(100vw - 108px);
      z-index: 0;
      margin-left: 100px; 
      transition: all 0.3s ease; 
      height: calc(100vh-100px); 
   

  }
  .sidebar ul li a {
      color: white; /* Set the font color to white */
      text-decoration: none; /* Remove the underline */
      font-weight: bold; /* Make the font bold */
      /* width: 90%; */
      text-align: center  ;
    }

    .radio-image{
      width: 20px;
      background-color: #fff;
      margin-left: 2px;
    }

    .nav{
      position: fixed;
      width: 100%;
      height: 40px;
      background-color: #1F2B8F;
      z-index: 1;
     margin-left: 200px;
     transition: all 0.3s ease; 
     display: flex;
     justify-content: flex-end;
    }

    
    .min-nav{
      position: fixed;
      left: 0%;
      width: 100%;
      height: 40px;
      background-color: #1F2B8F;
      z-index: 1;
      transition: all 0.3s ease; 
     margin-left: 100px;
     display: flex;
     justify-content: flex-end;
     /* align-items: center; */
    }

    .container{
      /* padding-left: 30px;
      padding-top: 30px; */
      border-radius: 50px;
      /* margin-left: -35px; */
      margin-left: 10px;
      transition: all 0.3s ease; 
  
    }

    .user-div{
      background-color: white;
      /* left:91%; */
      padding: 3px;
      border-radius: 10px;
      display: none;
      margin-top: 5px;
    }


    .user-div ul li{
          padding: 3px 5px;
          text-align: center;
          width: max-content;
          border-radius: 3px;
          cursor: pointer;
          font-size: small;
    }

    .user-div ul li:hover{
      background-color: #1F2B8F;
      color: #fff;

     
    }

    .user-maindiv{

      display: flex;
      padding: 5px;
      /* margin-top: 15px; */
      margin-right: 210px;
      transition: all 0.3s ease; 
      

    }
    .user-mindiv{

      display: flex;
      padding: 5px;
      /* margin-top: 15px; */
      margin-right: 120px;
      transition: all 0.3s ease; 
    }

    .user-icon:hover .user-div{
      display: block;
      box-shadow: 0px 0px 10px grey;
      cursor: pointer;
    }

    .user-icon:hover .user-icon-2{
      display: none;
    }

    
::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}


::-webkit-scrollbar-thumb {
  background-color: #888; 
  border-radius: 6px; 
}


::-webkit-scrollbar-corner {
  background-color: #f1f1f1; 
}

::-webkit-scrollbar{
  width: 4px;
  height: 4px;
}


.collect-div{
   margin-left: 50px;
   display: none;
}


.collect-div>ul> li{
  text-align: start !important;
  margin: 15px 0px;
  background-color: transparent !important;
  color: #FFFFFF;
  /* padding: 8px 8px 8px 10px; */
  /* padding: 5px; */
  width: 120px;
  cursor: pointer;
  
}

.collect-tab-link{
  all:unset !important
}


.collect-tab-link:hover{

    /* border-radius: 10px; */
    /* cursor: pointer; */
    padding: 5px;

}


.min-collect-div{
  margin-left: 10px;
  display: none;
}


.min-collect-div>ul> li{
 text-align: start !important;
 margin: 15px 0px;
 background-color: transparent !important;
 color: #FFFFFF;
 /* padding: 8px 8px 8px 10px; */
 /* padding: 5px; */
 width: 50px;
 cursor: pointer;
 
}

.min-collect-tab-link{
 all:unset !important
}


.min-collect-tab-link:hover{

   /* border-radius: 10px; */
   /* cursor: pointer; */
   padding: 5px;

}


/* 
.collect-div ul li {
  opacity: 0;
  transform: translateY(-20px);
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.collect-div ul li:nth-child(1) { transition-delay: 0.1s; }
.collect-div ul li:nth-child(2) { transition-delay: 0.2s; }
.collect-div ul li:nth-child(3) { transition-delay: 0.3s; }


.collect-div ul li.open {
  opacity: 1;
  transform: translateY(0);
} */`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AACA;EACE,UAAU;;AAEZ;;AAEA;EACE,QAAQ,EAAE,sDAAsD;AAClE;;AAEA;EACE,gBAAgB,EAAE,8CAA8C;AAClE;;AAEA;EACE,aAAa;EACb,+BAA+B,EAAE,qEAAqE;EACtG,iBAAiB;AACnB;;EAEE,gCAAgC;EAChC;MAEI,YAAY;MACZ,cAAc;MACd,cAAc;MACd,yBAAyB;OACxB,2BAA2B;OAC3B,aAAa;MACd,aAAa;MACb,sBAAsB;MACtB,yBAAyB;MACzB,kBAAkB;MAClB,uBAAuB;MACvB,yBAAyB;MACzB,aAAa;KACd,UAAU;QACP,eAAe;EACrB;EACA;MACI,YAAY;EAChB;;EAEA;MACI,YAAY;EAChB;;EAEA,6BAA6B;EAC7B;MACI,YAAY;MACZ,YAAY;MACZ,mBAAmB;MACnB,YAAY;MAEZ,mBAAmB;MACnB,kBAAkB;MAClB,sBAAsB;MACtB,4BAA4B;MAC5B,aAAa;MACb,uBAAuB;EAC3B;;EAEA;MACI,qBAAqB;MACrB,YAAY;MACZ,WAAW;EACf;;;EAGA;IACE,UAAU;EACZ;;EAEA,qCAAqC;EACrC;MACI,qBAAqB;MACrB,aAAa;MACb,SAAS;;EAEb;EACA;MACI,wBAAwB;MACxB;;EAEJ;EACA;MAEI,eAAe;MACf,uDAAuD;MACvD,mBAAmB;MACnB,cAAc;MACd,eAAe;MACf,iBAAiB;MACjB,WAAW;MACX,gBAAgB;MAChB,YAAY;MACZ,kBAAkB;MAClB,eAAe;MACf,wBAAwB;MACxB,YAAY;MACZ,mBAAmB;EACvB;;EAEA;IAEE,eAAe;IACf,uDAAuD;IACvD,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,wBAAwB;IACxB,WAAW;IACX,mBAAmB;;AAEvB;;;;EAIE;MACI,cAAc;MACd,aAAa;MACb,uBAAkB;MAAlB,kBAAkB;MAClB,4BAA4B;;AAElC,wDAAwD;IACpD;;IAEA;MACE,cAAc;MACd,aAAa;MACb,qBAAqB;;;;AAI3B,wDAAwD;IACpD;;EAEF;MACI,yBAAyB;MACzB,WAAW;MAEX,mBAAmB;EACvB;;EAEA;IACE,yBAAyB;IACzB,WAAW;IAEX,WAAW;IACX,mBAAmB;AACvB;;EAEE;MACI,yBAAyB;MACzB,mBAAmB;MACnB,eAAe;MACf,YAAY;EAChB;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,YAAY;AAChB;EACE;MACI,aAAa;MACb,eAAe;MACf,gBAAgB;MAChB,kBAAkB;MAClB,YAAY;MACZ,6BAA6B;;EAEjC;;EAEA,sCAAsC;EACtC;;MAEI,+BAA+B;MAC/B,UAAU;EACd;;EAEA;MACI,0BAA0B;EAC9B;;EAEA;MACI,uBAAuB;EAC3B;;EAEA;MACI,iBAAiB;MACjB,sBAAsB;MACtB,yBAAyB;MACzB,uBAAkB;MAAlB,kBAAkB;MAClB,kBAAkB;EACtB;;;EAGA;MACI,sEAAsE;MACtE,wBAAwB;MACxB,kBAAkB;OACjB;uEACgE;OAChE,2EAA2E;OAC3E,cAAc;MACf,QAAM;MACN,cAAc;MACd,gBAAgB;MAChB,mBAAmB;MACnB,0BAA0B;MAC1B,mBAAmB;MACnB,6BAA6B;MAC7B,yBAAyB;MACzB,UAAU;;MAEV;;+BAEyB;MACzB,wBAAwB;EAC5B;;EAEA;MACI,wBAAwB;MACxB,gBAAgB;MAChB,QAAM;MACN,kBAAkB;MAClB,0BAA0B;MAC1B,UAAU;MACV,kBAAkB;MAClB,yBAAyB;MACzB,yBAAyB;;;EAG7B;EACA;MACI,YAAY,EAAE,gCAAgC;MAC9C,qBAAqB,EAAE,yBAAyB;MAChD,iBAAiB,EAAE,uBAAuB;MAC1C,gBAAgB;MAChB,oBAAoB;IACtB;;IAEA;MACE,WAAW;MACX,sBAAsB;MACtB,gBAAgB;IAClB;;IAEA;MACE,eAAe;MACf,WAAW;MACX,YAAY;MACZ,yBAAyB;MACzB,UAAU;KACX,kBAAkB;KAClB,yBAAyB;KACzB,aAAa;KACb,yBAAyB;IAC1B;;;IAGA;MACE,eAAe;MACf,QAAQ;MACR,WAAW;MACX,YAAY;MACZ,yBAAyB;MACzB,UAAU;MACV,yBAAyB;KAC1B,kBAAkB;KAClB,aAAa;KACb,yBAAyB;KACzB,yBAAyB;IAC1B;;IAEA;MACE;0BACoB;MACpB,mBAAmB;MACnB,wBAAwB;MACxB,iBAAiB;MACjB,yBAAyB;;IAE3B;;IAEA;MACE,uBAAuB;MACvB,cAAc;MACd,YAAY;MACZ,mBAAmB;MACnB,aAAa;MACb,eAAe;IACjB;;;IAGA;UACM,gBAAgB;UAChB,kBAAkB;UAClB,kBAAkB;UAClB,kBAAkB;UAClB,eAAe;UACf,gBAAgB;IACtB;;IAEA;MACE,yBAAyB;MACzB,WAAW;;;IAGb;;IAEA;;MAEE,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,mBAAmB;MACnB,yBAAyB;;;IAG3B;IACA;;MAEE,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,mBAAmB;MACnB,yBAAyB;IAC3B;;IAEA;MACE,cAAc;MACd,6BAA6B;MAC7B,eAAe;IACjB;;IAEA;MACE,aAAa;IACf;;;AAGJ;EACE,yBAAyB;AAC3B;;;AAGA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;;AAGA;GACG,iBAAiB;GACjB,aAAa;AAChB;;;AAGA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,wCAAwC;EACxC,cAAc;EACd,+BAA+B;EAC/B,kBAAkB;EAClB,YAAY;EACZ,eAAe;;AAEjB;;AAEA;EACE;AACF;;;AAGA;;IAEI,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;;AAEhB;;;AAGA;EACE,iBAAiB;EACjB,aAAa;AACf;;;AAGA;CACC,4BAA4B;CAC5B,gBAAgB;CAChB,wCAAwC;CACxC,cAAc;CACd,+BAA+B;CAC/B,kBAAkB;CAClB,WAAW;CACX,eAAe;;AAEhB;;AAEA;CACC;AACD;;;AAGA;;GAEG,yBAAyB;GACzB,qBAAqB;GACrB,YAAY;;AAEf;;;AAGA;;;;;;;;;;;;;;;GAeG","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,400;0,500;0,700;1,400;1,500;1,700&display=swap\");\nbody{\n  margin: 0%;\n  \n}\n\nbody::-webkit-scrollbar {\n  width: 0; /* Set the width of the scrollbar to a minimal value */\n}\n\nbody:-webkit-scrollbar-thumb {\n  background: none; /* Set the scrollbar thumb to be transparent */\n}\n\n.app {\n  display: grid;\n  grid-template-columns: auto 1fr; /* Sidebar takes auto width, Main content takes the remaining space */\n  min-height: 100vh;\n}\n  \n  /* Add styling for the sidebar */\n  .sidebar {\n      flex-shrink: 0;\n      width: 100px;\n      flex: 0 0 auto;\n      flex-shrink: 0;\n      background-color: #1F2B8F;\n       transition: width 0.3s ease; \n       overflow:auto; \n      display: flex;\n      flex-direction: column;\n      /* align-items: center; */\n      margin-right: 10px;\n      /* max-height: 100vh; */\n      transition: all 0.3s ease; \n      height: 100vh;\n     z-index: 1; \n        position: fixed; \n  }\n  .open {\n      width: 200px;\n  }\n  \n  .closed {\n      width: 100px;\n  }\n  \n  /* Add styling for the logo */\n  .logo {\n      padding: 0px;\n      margin: 10px;\n      border-radius: 10px;\n      height: 60px;\n      display: flex;\n      align-items: center;\n      text-align: center;\n      /* color: aliceblue; */\n      /* background-color: #fff; */\n      display: flex;\n      justify-content: center;\n  }\n  \n  .main-logo {\n      /* max-width: 100%; */\n      width: 130px;\n      color: #fff;\n  }\n\n\n  .min-logo{\n    width:80px;\n  }\n  \n  /* Add styling for the sidebar tabs */\n  ul {\n      list-style-type: none;\n      padding: 10px;\n      margin: 0;\n\n  }\n  ul li{\n      /* width: fit-content; */\n      text-align: center !important \n    \n  }\n  li.tab {\n      padding: 10px;\n      cursor: pointer;\n      transition: background-color 0.3s ease, color 0.3s ease;\n      align-items: center;\n      display: block;\n      font-size: 16px;\n      font-weight: bold;\n      color: #fff;\n      margin-left: 5px;\n      padding: 5px;\n      text-align: center;\n      margin-top: 5px;\n      /* width: fit-content; */\n      width: 140px;\n      border-radius: 10px;\n  }\n\n  li.tab-min {\n    padding: 10px;\n    cursor: pointer;\n    transition: background-color 0.3s ease, color 0.3s ease;\n    align-items: center;\n    display: block;\n    font-size: 16px;\n    font-weight: bold;\n    color: #fff;\n    margin-left: 5px;\n    padding: 5px;\n    text-align: center;\n    margin-top: 5px;\n    /* width: fit-content; */\n    width: 50px;\n    border-radius: 10px;\n    \n}\n  \n\n\n  li.tab a {\n      display: block;\n      padding: 10px;\n      width: fit-content;\n      text-align: center !important\n      \n/* Adjust the padding as needed for the clickable area */\n    }\n\n    li.tab-min a {\n      display: block;\n      padding: 10px;\n      width: 50% !important;\n      \n    \n      \n/* Adjust the padding as needed for the clickable area */\n    }\n  \n  li.tab.active {\n      background-color: #50C878;\n      color:white;\n      border-radius: 15px;\n      border-radius: 10px;\n  }\n\n  li.tab-min.active {\n    background-color: #50C878;\n    color:white;\n    border-radius: 15px;\n    width: 50px;\n    border-radius: 10px;\n}\n  \n  li.tab:hover  {\n      background-color: #50C878;\n      border-radius: 10px;\n      cursor: pointer;\n      padding: 5px;\n  }\n  li.tab-min:hover  {\n    background-color: #50C878;\n    border-radius: 10px;\n    cursor: pointer;\n    padding: 5px;\n}\n  .collapse-icon {\n      padding: 10px;\n      cursor: pointer;\n      margin-top: auto;\n      text-align: center;\n      color: brown;\n      /* background-color: black; */\n      \n  }\n  \n  /* Add styling for the chevron icons */\n  .fa-chevron-left,\n  .fa-chevron-right {\n      transition: transform 0.3s ease;\n      color: red;\n  }\n  \n  .fa-chevron-left {\n      transform: rotate(-180deg);\n  }\n  \n  .fa-chevron-right {\n      transform: rotate(0deg);\n  }\n\n  .main-div{\n      /* z-index: 0;  */\n      /* position: sticky; */\n      /* padding-left: 500px; */\n      width: fit-content;\n      margin-left: 200px;\n  }\n\n\n  .main-content {\n      /* max-height: calc(100vh - 120px); Adjust the 120px value as needed */\n      height: calc(100vh-10px); \n      margin-left: 200px; \n       /* margin-top: 50px;  \n      /* Add any additional styles you want for the main content area */\n       /* This allows the main content area to grow and fill the remaining space */\n       overflow: auto;\n      flex:1;\n      flex-shrink: 0;\n      margin-top: 38px;\n      /* width: 1150px; */\n      width: calc(100vw - 200px);\n      /* display: flex; */\n      /* justify-content: center; */\n      transition: all 0.3s ease; \n      z-index: 0;\n    \n      /* transition: all 0.3s ease; \n     \n      /* border-radius: 50px; */\n      /* padding-left: 30px; */\n  }\n\n  .min-content{\n      /* min-height: 100vh;  */\n      margin-top: 38px;\n      flex:1;\n      /* width: 100vw; */\n      width: calc(100vw - 108px);\n      z-index: 0;\n      margin-left: 100px; \n      transition: all 0.3s ease; \n      height: calc(100vh-100px); \n   \n\n  }\n  .sidebar ul li a {\n      color: white; /* Set the font color to white */\n      text-decoration: none; /* Remove the underline */\n      font-weight: bold; /* Make the font bold */\n      /* width: 90%; */\n      text-align: center  ;\n    }\n\n    .radio-image{\n      width: 20px;\n      background-color: #fff;\n      margin-left: 2px;\n    }\n\n    .nav{\n      position: fixed;\n      width: 100%;\n      height: 40px;\n      background-color: #1F2B8F;\n      z-index: 1;\n     margin-left: 200px;\n     transition: all 0.3s ease; \n     display: flex;\n     justify-content: flex-end;\n    }\n\n    \n    .min-nav{\n      position: fixed;\n      left: 0%;\n      width: 100%;\n      height: 40px;\n      background-color: #1F2B8F;\n      z-index: 1;\n      transition: all 0.3s ease; \n     margin-left: 100px;\n     display: flex;\n     justify-content: flex-end;\n     /* align-items: center; */\n    }\n\n    .container{\n      /* padding-left: 30px;\n      padding-top: 30px; */\n      border-radius: 50px;\n      /* margin-left: -35px; */\n      margin-left: 10px;\n      transition: all 0.3s ease; \n  \n    }\n\n    .user-div{\n      background-color: white;\n      /* left:91%; */\n      padding: 3px;\n      border-radius: 10px;\n      display: none;\n      margin-top: 5px;\n    }\n\n\n    .user-div ul li{\n          padding: 3px 5px;\n          text-align: center;\n          width: max-content;\n          border-radius: 3px;\n          cursor: pointer;\n          font-size: small;\n    }\n\n    .user-div ul li:hover{\n      background-color: #1F2B8F;\n      color: #fff;\n\n     \n    }\n\n    .user-maindiv{\n\n      display: flex;\n      padding: 5px;\n      /* margin-top: 15px; */\n      margin-right: 210px;\n      transition: all 0.3s ease; \n      \n\n    }\n    .user-mindiv{\n\n      display: flex;\n      padding: 5px;\n      /* margin-top: 15px; */\n      margin-right: 120px;\n      transition: all 0.3s ease; \n    }\n\n    .user-icon:hover .user-div{\n      display: block;\n      box-shadow: 0px 0px 10px grey;\n      cursor: pointer;\n    }\n\n    .user-icon:hover .user-icon-2{\n      display: none;\n    }\n\n    \n::-webkit-scrollbar-track {\n  background-color: #f1f1f1;\n}\n\n\n::-webkit-scrollbar-thumb {\n  background-color: #888; \n  border-radius: 6px; \n}\n\n\n::-webkit-scrollbar-corner {\n  background-color: #f1f1f1; \n}\n\n::-webkit-scrollbar{\n  width: 4px;\n  height: 4px;\n}\n\n\n.collect-div{\n   margin-left: 50px;\n   display: none;\n}\n\n\n.collect-div>ul> li{\n  text-align: start !important;\n  margin: 15px 0px;\n  background-color: transparent !important;\n  color: #FFFFFF;\n  /* padding: 8px 8px 8px 10px; */\n  /* padding: 5px; */\n  width: 120px;\n  cursor: pointer;\n  \n}\n\n.collect-tab-link{\n  all:unset !important\n}\n\n\n.collect-tab-link:hover{\n\n    /* border-radius: 10px; */\n    /* cursor: pointer; */\n    padding: 5px;\n\n}\n\n\n.min-collect-div{\n  margin-left: 10px;\n  display: none;\n}\n\n\n.min-collect-div>ul> li{\n text-align: start !important;\n margin: 15px 0px;\n background-color: transparent !important;\n color: #FFFFFF;\n /* padding: 8px 8px 8px 10px; */\n /* padding: 5px; */\n width: 50px;\n cursor: pointer;\n \n}\n\n.min-collect-tab-link{\n all:unset !important\n}\n\n\n.min-collect-tab-link:hover{\n\n   /* border-radius: 10px; */\n   /* cursor: pointer; */\n   padding: 5px;\n\n}\n\n\n/* \n.collect-div ul li {\n  opacity: 0;\n  transform: translateY(-20px);\n  transition: opacity 0.3s ease, transform 0.3s ease;\n}\n\n.collect-div ul li:nth-child(1) { transition-delay: 0.1s; }\n.collect-div ul li:nth-child(2) { transition-delay: 0.2s; }\n.collect-div ul li:nth-child(3) { transition-delay: 0.3s; }\n\n\n.collect-div ul li.open {\n  opacity: 1;\n  transform: translateY(0);\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
